import { j as o } from "./index.es44.js";
import { composeClassNames as e } from "./index.es126.js";
const b = ({
  children: s = null,
  header: n,
  state: a = "info",
  hasNoIcon: i = !1,
  ariaLive: l
}) => /* @__PURE__ */ o.jsx(
  "div",
  {
    className: e("bl-info-box", `bl-info-box--${a}`),
    ...l && { "aria-live": l },
    children: /* @__PURE__ */ o.jsxs("div", { className: "bl-info-box__wrapper", children: [
      n && /* @__PURE__ */ o.jsxs(
        "div",
        {
          className: e(
            "bl-info-box__header",
            i && "bl-info-box__header--no-icon"
          ),
          children: [
            !i && /* @__PURE__ */ o.jsx(
              "i",
              {
                "aria-hidden": "true",
                className: e(
                  "bl-info-box__icon",
                  `bl-icon--${a}`,
                  "bl-icon--medium"
                )
              }
            ),
            /* @__PURE__ */ o.jsx("div", { className: "bl-info-box__header-content", children: n })
          ]
        }
      ),
      s && /* @__PURE__ */ o.jsx(
        "div",
        {
          className: e(
            "bl-info-box__content",
            i && "bl-info-box__content--no-icon",
            !n && "bl-info-box__content--no-header"
          ),
          children: s
        }
      )
    ] })
  }
);
export {
  b as default
};
//# sourceMappingURL=index.es77.js.map
